import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default function SimpleModal({ open, onClose, title, subtitle, children, width = "max-w-md" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-lg shadow-xl w-full ${width} mx-4 max-h-[85vh] flex flex-col`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Client, 2: "Add up to 2 indicators - should be the subtitle line under
            the modal header:
              Indicators
              Add up to 2 indicators"

            It was rendering in the modal BODY, which put the header's divider
            between the title and its own subtitle. As a `subtitle` slot it sits
            with the title, above the rule, and reads as one header block. */}
        <div className="px-4 py-3 border-b">
          <div className="flex items-start justify-between">
            <h3 className="text-base font-semibold text-gray-800">{title}</h3>
            <button
              type="button"
              onClick={onClose}
              className="w-8 h-8 -mt-1 flex items-center justify-center rounded hover:bg-gray-100 text-gray-500"
              aria-label="Close"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          {subtitle && (
            <p className="mt-0.5 text-xs text-secondary">{subtitle}</p>
          )}
        </div>
        <div className="p-4 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
